import { render } from "./AdminYellowConsultantUpdate.vue?vue&type=template&id=2f2078a8"
import script from "./AdminYellowConsultantUpdate.vue?vue&type=script&lang=js"
export * from "./AdminYellowConsultantUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__